'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// import moment from 'moment';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _support = require('helpers/support');

var _reactRedux = require('react-redux');

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _analytics = require('redux/modules/analytics');

var analyticsActions = _interopRequireWildcard(_analytics);

var _components = require('components');

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Modal } from 'react-bootstrap';
var StepOne = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    submit: state.booking.submit,
    weeks: state.booking.weeks,
    week: state.booking.week,
    weekUI: state.booking.weekUI,
    bookingTime: state.booking.bookingTime,
    shop: state.booking.shop,
    branchs: state.booking.branchs,
    services: state.booking.services,
    provinces: state.address.provinces,
    districts: state.booking.districts
  };
}, {
  loadSlots: bookingActions.loadSlots,
  loadWeek: bookingActions.loadWeek,
  nextWeek: bookingActions.nextWeek,
  previousWeek: bookingActions.previousWeek,
  changeDate: bookingActions.changeDate,
  changeShop: bookingActions.changeShop,
  loadBookingTime: bookingActions.loadBookingTime,
  changeBookingTime: bookingActions.changeBookingTime,
  setBranch: bookingActions.setBranch,
  resetByBranch: bookingActions.resetByBranch,
  removeCoupon: bookingActions.removeCoupon,
  changeProvinceBooking: bookingActions.changeProvinceBooking,
  changeDistrictBooking: bookingActions.changeDistrictBooking,
  loadDistrictBooking: bookingActions.loadDistrictBooking,
  manualTrack: analyticsActions.manualTrack

}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(StepOne, _Component);

  function StepOne() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, StepOne);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepOne.__proto__ || (0, _getPrototypeOf2.default)(StepOne)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showBranch: false,
      showInfo: false,
      info: { title: {}, message: [] },
      FooterUI: {
        label: 'Bạn chọn khung giờ',
        main: '',
        btnLabel: 'TIẾP THEO'
      }
    }, _this.trackingData = function () {
      var shop = _this.props.submit.shop;

      return { shopId: shop.id };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(StepOne, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      _support.Helper.warn('componentWillMount vào step one');
      var loadSlots = this.props.loadSlots;
      var handle = this.props.submit.shop.handle;

      loadSlots(handle);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          loadWeek = _props.loadWeek,
          loadBookingTime = _props.loadBookingTime;

      if (!(0, _lodash.isEqual)(this.props.weeks, nextProps.weeks)) {
        loadWeek();
      }
      if (!(0, _lodash.isEqual)(this.props.week, nextProps.week) && nextProps.week && nextProps.week.length && !nextProps.submit.dateSelected) {
        var firstDayStillHasSlots = nextProps.week.find(function (v) {
          return v.empty > 0;
        });
        if (firstDayStillHasSlots && firstDayStillHasSlots.date) {
          this.changeDate(firstDayStillHasSlots, true);
        }
      }
      if (!(0, _lodash.isEqual)(this.props.submit.dateSelected, nextProps.submit.dateSelected) && nextProps.submit.dateSelected) {
        var dataDate = nextProps.submit.dateSelected;
        loadBookingTime(dataDate.date);
      }
    }
  }, {
    key: 'hideInfo',
    value: function hideInfo() {
      this.setState({ showInfo: false });
    }
  }, {
    key: 'showBranch',
    value: function showBranch() {
      this.setState({ showBranch: true });
    }
  }, {
    key: 'hideBranch',
    value: function hideBranch() {
      this.setState({ showBranch: false });
    }
  }, {
    key: 'onChangeBranchShop',
    value: function onChangeBranchShop(shop) {
      var _this2 = this;

      this.props.changeShop(shop, function (info) {
        console.log(info);
        _this2.setState({ info: info, showInfo: true });
      });
    }
  }, {
    key: 'onNextWeek',
    value: function onNextWeek() {
      this.props.nextWeek();
    }
  }, {
    key: 'onPreviousWeek',
    value: function onPreviousWeek() {
      this.props.previousWeek();
    }
  }, {
    key: 'changeDate',
    value: function changeDate(data, force) {
      var dataSelected = this.props.submit.dataSelected;

      if (force && data.date || !dataSelected || dataSelected.date !== data.date) {
        this.props.changeDate(data);
      }
    }
  }, {
    key: 'selectBookingTime',
    value: function selectBookingTime(data) {
      var bookingTimeId = this.props.submit.bookingTimeId;

      if (data._id !== bookingTimeId) {
        this.props.changeBookingTime(data);
      }
    }
  }, {
    key: 'fillContactInfo',
    value: function fillContactInfo(_ref2) {
      var shop = _ref2.shop,
          province = _ref2.province,
          provinces = _ref2.provinces,
          district = _ref2.district,
          districts = _ref2.districts,
          changeDistrictBooking = _ref2.changeDistrictBooking,
          changeProvinceBooking = _ref2.changeProvinceBooking,
          loadDistrictBooking = _ref2.loadDistrictBooking;

      var isFreelance = shop.shopType === 'freelance';
      var _province = isFreelance ? '79' : province;
      // console.log('fillContactInfo', provinces, province);
      if (provinces && _province) {
        var userProvince = provinces.find(function (prov) {
          return prov.code === _province;
        });
        if (!districts || !districts.length) {
          loadDistrictBooking(userProvince.code);
        }
        changeProvinceBooking(userProvince);
      }

      if ((isFreelance && province === '79' || !isFreelance) && districts && district) {
        var userDistrict = districts.find(function (dist) {
          return dist.code === district;
        });
        changeDistrictBooking(userDistrict);
      }
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      var _this3 = this;

      // TODO: kiểm tra điều kiện trước khi chuyển qua step 2.
      var _props2 = this.props,
          _props2$submit = _props2.submit,
          dateSelected = _props2$submit.dateSelected,
          time = _props2$submit.time,
          shop = _props2$submit.shop,
          coupon = _props2$submit.coupon,
          atHome = _props2$submit.atHome,
          district = _props2$submit.district,
          province = _props2$submit.province,
          services = _props2.services,
          history = _props2.history,
          removeCoupon = _props2.removeCoupon,
          changeDistrictBooking = _props2.changeDistrictBooking,
          changeProvinceBooking = _props2.changeProvinceBooking,
          loadDistrictBooking = _props2.loadDistrictBooking,
          provinces = _props2.provinces,
          districts = _props2.districts;

      if (dateSelected === null || time === null) {
        var title = { text: 'Thông Báo', type: 'warn' };
        var message = [{ text: 'Vui lòng chọn ngày giờ đặt chỗ' }];
        var info = { title: title, message: message };
        this.setState({ info: info, showInfo: true });
      } else {
        if (atHome) {
          this.fillContactInfo({
            shop: shop,
            province: province,
            provinces: provinces,
            district: district,
            districts: districts,
            changeDistrictBooking: changeDistrictBooking,
            changeProvinceBooking: changeProvinceBooking,
            loadDistrictBooking: loadDistrictBooking
          });
        }
        if (coupon && coupon.packageService && !_support.Helper.serviceIsExist(coupon.packageService.serviceRewrite._id, services)) {
          _support.Helper.warn('nextStep', coupon, services);
          var _title = { text: 'Thông Báo', type: 'warn' };
          var _message = [{
            text: 'M\xE3 code ' + coupon.code + ' kh\xF4ng kh\u1EA3 d\u1EE5ng cho shop n\xE0y! B\u1EA1n c\xF3 mu\u1ED1n ti\u1EBFp t\u1EE5c \u0111\u1EB7t l\u1ECBch hay kh\xF4ng?'
          }];
          var button = [{
            text: 'Tiếp Tục',
            onClick: function () {
              var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return removeCoupon();

                      case 2:
                        history.push('/dat-lich-2');

                      case 3:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this3);
              }));

              return function onClick() {
                return _ref3.apply(this, arguments);
              };
            }()
          }, {
            text: 'Thoát',
            onClick: function onClick() {
              return _this3.hideInfo();
            }
          }];
          var _info = { title: _title, message: _message, button: button };
          this.setState({ info: _info, showInfo: true });
        } else {
          history.push('/dat-lich-2');
          _reactGa2.default.event({
            category: 'Booking',
            action: 'Clicked To Step 2',
            label: '' + shop.name
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./StepOne.scss');
      var _state = this.state,
          info = _state.info,
          showInfo = _state.showInfo,
          showBranch = _state.showBranch;
      var _props3 = this.props,
          week = _props3.week,
          weekUI = _props3.weekUI,
          branchs = _props3.branchs,
          _props3$submit = _props3.submit,
          dateSelected = _props3$submit.dateSelected,
          bookingTimeId = _props3$submit.bookingTimeId,
          time = _props3$submit.time,
          shop = _props3$submit.shop,
          bookingTime = _props3.bookingTime;

      var FooterUI = (0, _extends3.default)({}, this.state.FooterUI, {
        main: _support.Helper.toTimeBooking(dateSelected ? dateSelected.date : '', time ? time.time : null)
      });
      var tracking = this.trackingData();
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          !!(branchs && branchs.length) && _react2.default.createElement(
            'div',
            { className: styles.box },
            _react2.default.createElement(
              'label',
              null,
              'Ch\u1ECDn chi nh\xE1nh'
            ),
            _react2.default.createElement(_components.SelectShop, {
              show: showBranch,
              placeHolder: 'Vui l\xF2ng ch\u1ECDn chi nh\xE1nh.',
              activeShop: shop,
              onHide: this.hideBranch.bind(this),
              onShow: this.showBranch.bind(this),
              onChange: this.onChangeBranchShop.bind(this),
              data: branchs
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.box },
            _react2.default.createElement(
              'label',
              null,
              'Ch\u1ECDn ng\xE0y'
            ),
            _react2.default.createElement(_components.WeeklyDayPicker, {
              data: { week: week, weekUI: weekUI, selected: dateSelected },
              onChange: this.changeDate.bind(this),
              onNext: this.onNextWeek.bind(this),
              onPrevious: this.onPreviousWeek.bind(this)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.box },
            _react2.default.createElement(
              'label',
              null,
              'Ch\u1ECDn gi\u1EDD'
            ),
            _react2.default.createElement(_components.BookingTime, {
              data: { bookingTime: bookingTime, bookingTimeId: bookingTimeId, shop: shop },
              onChange: this.selectBookingTime.bind(this)
            })
          )
        ),
        _react2.default.createElement(_components.FooterBooking, { tracking: (0, _extends3.default)({}, tracking, { button: 'Continue' }), manualTrack: this.props.manualTrack, data: FooterUI, onClick: this.nextStep.bind(this) }),
        _react2.default.createElement(_components.ModalCustom, {
          show: showInfo,
          onHide: this.hideInfo.bind(this),
          title: info.title,
          message: info.message,
          button: info.button,
          closeButton: true
        })
      );
    }
  }]);
  return StepOne;
}(_react.Component), _class2.propTypes = {
  // @action
  loadSlots: _react.PropTypes.func,
  loadWeek: _react.PropTypes.func,
  loadBookingTime: _react.PropTypes.func,
  nextWeek: _react.PropTypes.func,
  previousWeek: _react.PropTypes.func,
  changeDate: _react.PropTypes.func,
  changeShop: _react.PropTypes.func,
  changeBookingTime: _react.PropTypes.func,
  setBranch: _react.PropTypes.func,
  resetByBranch: _react.PropTypes.func,
  removeCoupon: _react.PropTypes.func,
  districts: _react.PropTypes.array,
  provinces: _react.PropTypes.array,
  // @data
  // shopId: PropTypes.string,
  submit: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  weeks: _react.PropTypes.object,
  week: _react.PropTypes.array,
  weekUI: _react.PropTypes.object,
  bookingTime: _react.PropTypes.array,
  services: _react.PropTypes.array,
  branchs: _react.PropTypes.array,
  history: _react.PropTypes.object,
  changeDistrictBooking: _react.PropTypes.func,
  changeProvinceBooking: _react.PropTypes.func,
  loadDistrictBooking: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = StepOne;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Booking/StepOne.js
// module id = 1534
// module chunks = 0